var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getAllLayers, getSelectedSections, getSortedSectionsArray, } from 'pxc-editor-core/helpers/schema';
import Section from 'pxc-editor-core/entities/Section';
import { overridePageAction, overridePagesAction, checkSyncSlaveShieldBySection, } from '@/actions/page';
import { createNewPage, getShieldsByGroupId } from '@/helpers';
import { changePageChildrenLength, createSnapshotThunk } from '@/actions';
export var callN1FunctionThunk = function () {
    return function (dispatch, getState) {
        var _a;
        var _b = getState().core, pages = _b.pages, pagesOrder = _b.pagesOrder, pagesSelection = _b.pagesSelection, sectionsSelection = _b.sectionsSelection, selWizard = _b.selWizard;
        if (!Object.keys(sectionsSelection).length) {
            return;
        }
        dispatch(createSnapshotThunk());
        var isCableFlag = (selWizard === null || selWizard === void 0 ? void 0 : selWizard.application_type) === 'CABLE_FLAG';
        var _c = __read(pagesSelection, 1), currentPageUid = _c[0];
        var currentPageIndex = pagesOrder.findIndex(function (uid) { return uid === currentPageUid; });
        var currentPage = pages[currentPageUid];
        var selectedSections = getSortedSectionsArray(getSelectedSections({
            sectionsSelection: sectionsSelection,
            page: currentPage,
        }));
        var _d = __read(selectedSections, 1), selectedSection = _d[0];
        var layers = getAllLayers(selectedSection.shieldId, pages);
        if (!layers.group)
            return;
        if (!layers.shield)
            return null;
        var groupId = layers.group.id;
        var curShieldId = layers.shield.id;
        var nextSection = findNextSection({
            curSectionId: selectedSection.id,
            curShieldId: curShieldId,
            curGroupId: groupId,
            currentPage: currentPage,
        });
        var contentSettingsToApply = Section.getContentSettings(selectedSection);
        if (isCableFlag) {
            if ((_a = selWizard === null || selWizard === void 0 ? void 0 : selWizard.data) === null || _a === void 0 ? void 0 : _a.isCableFlagSync) {
                var updateCurrentSection_1 = !selectedSection.text;
                var isNextSectionOnThisPage_1 = (function () {
                    var sectionsDict = Object.values(currentPage.sections).reduce(function (acc, section) {
                        var _a;
                        if (curShieldId === section.shieldId) {
                            return __assign(__assign({}, acc), (_a = {}, _a[section.id] = section, _a));
                        }
                        return acc;
                    }, {});
                    var sections = getSortedSectionsArray(sectionsDict);
                    var curSectionIndex = sections.findIndex(function (section) { return section.id === selectedSection.id; });
                    if (curSectionIndex === -1)
                        return null;
                    if (curSectionIndex < sections.length - 1)
                        return sections[curSectionIndex + 1];
                })();
                if (updateCurrentSection_1 || isNextSectionOnThisPage_1) {
                    var data = getCurrentPageData({
                        pages: pages,
                        currentPage: currentPage,
                        selectedSection: selectedSection,
                        nextSection: nextSection,
                        updateCurrentSection: updateCurrentSection_1,
                        contentSettingsToApply: contentSettingsToApply,
                    });
                    dispatch(overridePageAction({
                        page: data.page,
                        shieldsSelection: makeShieldsSelection(data.shield),
                        sectionsSelection: makeSectionsSelection(data.section),
                    }));
                    dispatch(checkSyncSlaveShieldBySection(data.section));
                    dispatch(changePageChildrenLength(data.page.uid));
                }
                else {
                    var data = getNextPageData({
                        pagesOrder: pagesOrder,
                        currentPageIndex: currentPageIndex,
                        pages: pages,
                        groupId: groupId,
                        selectedSection: selectedSection,
                        contentSettingsToApply: contentSettingsToApply,
                        currentPageUid: currentPageUid,
                    });
                    dispatch(overridePagesAction({
                        pages: data.pages,
                        pagesOrder: data.pagesOrder,
                        shieldsSelection: makeShieldsSelection(data.shield),
                        sectionsSelection: makeSectionsSelection(data.section),
                        paginationPageNum: data.paginationPageNum,
                        pagesSelection: [data.page.uid],
                    }));
                    dispatch(checkSyncSlaveShieldBySection(data.section));
                    dispatch(changePageChildrenLength(data.page.uid));
                }
                return;
            }
        }
        var updateCurrentSection = !selectedSection.text;
        var isNextSectionOnThisPage = !!nextSection;
        if (updateCurrentSection || isNextSectionOnThisPage) {
            var data = getCurrentPageData({
                pages: pages,
                currentPage: currentPage,
                selectedSection: selectedSection,
                nextSection: nextSection,
                updateCurrentSection: updateCurrentSection,
                contentSettingsToApply: contentSettingsToApply,
            });
            dispatch(overridePageAction({
                page: data.page,
                shieldsSelection: makeShieldsSelection(data.shield),
                sectionsSelection: makeSectionsSelection(data.section),
            }));
        }
        else {
            var data = getNextPageData({
                pagesOrder: pagesOrder,
                currentPageIndex: currentPageIndex,
                pages: pages,
                groupId: groupId,
                selectedSection: selectedSection,
                contentSettingsToApply: contentSettingsToApply,
                currentPageUid: currentPageUid,
            });
            dispatch(overridePagesAction({
                pages: data.pages,
                pagesOrder: data.pagesOrder,
                shieldsSelection: makeShieldsSelection(data.shield),
                sectionsSelection: makeSectionsSelection(data.section),
                paginationPageNum: data.paginationPageNum,
                pagesSelection: [data.page.uid],
            }));
        }
    };
};
var getCurrentPageData = function (payload) {
    var _a;
    var pages = payload.pages, currentPage = payload.currentPage, selectedSection = payload.selectedSection, nextSection = payload.nextSection, updateCurrentSection = payload.updateCurrentSection, contentSettingsToApply = payload.contentSettingsToApply;
    //we are staying on the current page
    var updatedSection = updateCurrentSection
        ? //case when we are updating the current selected section
            updateSectionContent(__assign(__assign({}, selectedSection), { text: selectedSection.text }))
        : //case when we are updating the next to selected section, but on the current page
            updateSectionContent(__assign(__assign({}, Section.resetContent(nextSection)), { text: selectedSection.text }));
    var changedSection = __assign(__assign({}, updatedSection), contentSettingsToApply);
    var updatedPage = __assign(__assign({}, currentPage), { sections: __assign(__assign({}, currentPage.sections), (_a = {}, _a[changedSection.id] = changedSection, _a)) });
    var currentShield = getAllLayers(updatedSection.shieldId, pages).shield;
    return { page: updatedPage, shield: currentShield, section: changedSection };
};
var getNextPageData = function (payload) {
    var _a, _b;
    var pagesOrder = payload.pagesOrder, currentPageIndex = payload.currentPageIndex, pages = payload.pages, groupId = payload.groupId, selectedSection = payload.selectedSection, contentSettingsToApply = payload.contentSettingsToApply, currentPageUid = payload.currentPageUid;
    //next section on the next page, we need to update pages and select next page
    var nextPage = getNextPage(pagesOrder, currentPageIndex, pages);
    var _c = findNextShieldAndSection(groupId, nextPage), nextShield = _c.nextShield, nextSection = _c.nextSection;
    var updatedNextSection = updateSectionContent(__assign(__assign({}, Section.resetContent(nextSection)), { text: selectedSection.text }));
    var changedSection = __assign(__assign({}, updatedNextSection), contentSettingsToApply);
    var updatedPages = __assign(__assign({}, pages), (_a = {}, _a[nextPage.uid] = __assign(__assign({}, nextPage), { sections: __assign(__assign({}, nextPage.sections), (_b = {}, _b[changedSection.id] = changedSection, _b)) }), _a));
    var updatedPagesOrder = pagesOrder.reduce(function (acc, pageUid) {
        if (acc.includes(pageUid)) {
            return acc;
        }
        else if (pageUid === currentPageUid) {
            return __spreadArray(__spreadArray([], __read(acc), false), [pageUid, nextPage.uid], false);
        }
        return __spreadArray(__spreadArray([], __read(acc), false), [pageUid], false);
    }, []);
    var paginationPageNum = updatedPagesOrder.findIndex(function (uid) { return uid === nextPage.uid; }) + 1;
    return {
        pages: updatedPages,
        pagesOrder: updatedPagesOrder,
        page: nextPage,
        shield: nextShield,
        section: nextSection,
        paginationPageNum: paginationPageNum,
    };
};
var findNextSection = function (data) {
    var curSectionId = data.curSectionId, curShieldId = data.curShieldId, curGroupId = data.curGroupId, currentPage = data.currentPage;
    var sectionsDict = Object.values(currentPage.sections).reduce(function (acc, section) {
        var _a;
        if (curShieldId === section.shieldId) {
            return __assign(__assign({}, acc), (_a = {}, _a[section.id] = section, _a));
        }
        return acc;
    }, {});
    var sections = getSortedSectionsArray(sectionsDict);
    var curSectionIndex = sections.findIndex(function (section) { return section.id === curSectionId; });
    if (curSectionIndex === -1)
        return null;
    if (curSectionIndex < sections.length - 1)
        return sections[curSectionIndex + 1];
    //here we need to look for the next section in the next shield
    var currentPageGroupShields = Object.values(getShieldsByGroupId({ id: curGroupId, page: currentPage }));
    var curShieldIndex = currentPageGroupShields.findIndex(function (shield) { return shield.id === curShieldId; });
    if (curShieldIndex === -1)
        return null;
    if (curShieldIndex < currentPageGroupShields.length - 1) {
        var nextShield_1 = currentPageGroupShields[curShieldIndex + 1];
        var nextShieldSectionsDict = Object.values(currentPage.sections).reduce(function (acc, section) {
            var _a;
            if (nextShield_1.id === section.shieldId) {
                return __assign(__assign({}, acc), (_a = {}, _a[section.id] = section, _a));
            }
            return acc;
        }, {});
        var _a = __read(getSortedSectionsArray(nextShieldSectionsDict), 1), nextShieldSection = _a[0];
        return nextShieldSection;
    }
    return null;
};
var makeShieldsSelection = function (shield) {
    var _a;
    return shield ? (_a = {}, _a[shield.id] = shield, _a) : {};
};
var makeSectionsSelection = function (section) {
    var _a;
    return (_a = {},
        _a[section.id] = section,
        _a);
};
var getNextPage = function (pagesOrder, currentPageIndex, pages) {
    var nextPageUid = pagesOrder[currentPageIndex + 1];
    var isNextPageAvailable = !!nextPageUid;
    return isNextPageAvailable ? pages[nextPageUid] : createNewPage();
};
var findNextShieldAndSection = function (groupId, nextPage) {
    var nextShields = getShieldsByGroupId({
        id: groupId,
        page: nextPage,
    });
    var _a = __read(Object.values(nextShields), 1), nextShield = _a[0];
    var nextShieldSectionsDict = Object.values(nextPage.sections).reduce(function (acc, section) {
        var _a;
        if (section.shieldId === nextShield.id) {
            return __assign(__assign({}, acc), (_a = {}, _a[section.id] = section, _a));
        }
        return acc;
    }, {});
    var _b = __read(getSortedSectionsArray(nextShieldSectionsDict), 1), nextShieldSection = _b[0];
    return { nextShield: nextShield, nextSection: nextShieldSection };
};
var updateSectionContent = function (section) {
    if (!!section.text) {
        var isNumber = /^-?\d+(\.\d+)?$/.test(section.text);
        var isLastLettersNumber = section.text.match(/^(.*?)(\d+)$/);
        if (isNumber) {
            var number = +section.text;
            var text = "".concat(number + 1);
            return __assign(__assign({}, section), { text: text });
        }
        else if (isLastLettersNumber) {
            var _a = __read(isLastLettersNumber, 3), _ = _a[0], stringPart = _a[1], numberPart = _a[2];
            var number = +numberPart + 1;
            var text = "".concat(stringPart).concat(number);
            return __assign(__assign({}, section), { text: text });
        }
        else {
            var text = "".concat(section.text).concat(1);
            return __assign(__assign({}, section), { text: text });
        }
    }
    return __assign(__assign({}, Section.resetContent(section)), { text: '1' });
};
